import { useState } from "react";

export function UploadStage({ onFile }: { onFile: (file: File) => void }) {
	const [dragging, setDragging] = useState(false);

	function handleFile(file: File | null | undefined) {
		if (!file) return;
		if (!file.type.startsWith("image/")) return;
		onFile(file);
	}

	return (
		<div className="absolute inset-0 flex items-center justify-center p-6">
			<label
				htmlFor="question-file"
				onDragEnter={(e) => {
					e.preventDefault();
					setDragging(true);
				}}
				onDragOver={(e) => {
					e.preventDefault();
					setDragging(true);
				}}
				onDragLeave={() => setDragging(false)}
				onDrop={(e) => {
					e.preventDefault();
					setDragging(false);
					handleFile(e.dataTransfer.files?.[0]);
				}}
				className={`block w-full max-w-2xl border-2 border-dashed rounded-2xl py-24 px-6 text-center cursor-pointer transition-colors ${
					dragging
						? "border-blue-500 bg-blue-50"
						: "border-zinc-300 hover:border-zinc-400 hover:bg-zinc-50"
				}`}
			>
				<p className="text-xl font-medium text-zinc-800">
					Upload a math question image
				</p>
				<p className="mt-2 text-sm text-zinc-500">
					Click to browse or drop an image here
				</p>
				<input
					id="question-file"
					type="file"
					accept="image/*"
					className="hidden"
					onChange={(e) => handleFile(e.target.files?.[0])}
				/>
			</label>
		</div>
	);
}
